import { Customer, CustomerFormData } from '../types';

const convertCustomer = (customer: Customer): CustomerFormData => {
  return {
    Id: customer.Id,
    Name: customer.Name || '',
    TypeId: customer.TypeId || null,
    TypeTitle: customer.TypeTitle || '',
    Address: customer.Address || '',
    WorkPhone: customer.WorkPhone || '',
    CellPhone: customer.CellPhone || '',
    HomePhone: customer.HomePhone || '',
    WorkEmail: customer.WorkEmail || '',
    PersonalEmail: customer.PersonalEmail || '',
    OtherEmail: customer.OtherEmail || '',
  };
};

export default convertCustomer;
